<main class="projects" [hidden]="spinner">
  <header class="projects--header">
    <div class="projects--header__container">
      <h5 class="projects--header__title">
        {{ 'newRequestProject' | i18next }}
      </h5>
      <div id="stepperHeader"></div>
    </div>
  </header>
  <app-stepper
    [user]="user"
    [requestType]="requestTypeEnum.proyect"
    [steps]="steps"
    (sendRequestEmitter)="sendRequest($event)"
  ></app-stepper>
</main>
<div class="text-center spinner-container" [hidden]="!spinner">
  <div class="spinner-border spinner" role="status"></div>
</div>
